export default function (state) {
    return state.items.concat([]).sort((a, b) => {
        if (a.main) return -1;
        if (b.main) return 1;
        else return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
}